import { render, staticRenderFns } from "./SchoolsList.vue?vue&type=template&id=2abf0bfe&scoped=true&"
import script from "./SchoolsList.vue?vue&type=script&lang=js&"
export * from "./SchoolsList.vue?vue&type=script&lang=js&"
import style0 from "./SchoolsList.vue?vue&type=style&index=0&id=2abf0bfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abf0bfe",
  null
  
)

export default component.exports